
export default {
  // Common
  "language": "Idioma",
  "language_description": "Cambiar el idioma utilizado en toda la aplicación",
  "save_language": "Guardar preferencia de idioma",
  "updating": "Actualizando...",
  "return_home": "Volver al inicio",
  "sign_out": "Cerrar sesión",
  "error": "Error",
  "loading": "Cargando...",
  "cancel": "Cancelar",
  "save": "Guardar",
  "edit": "Editar",
  "delete": "Eliminar",
  "back": "Atrás",
  "view_details": "Ver detalles",
  "not_applicable": "N/A",
  "invalid_date": "Fecha inválida",
  "name": "Nombre",
  "qty": "Cant.",
  "actions": "Acciones",
  "sort_by": "Ordenar por",
  "filter_by": "Filtrar por",
  "ascending": "Ascendente",
  "descending": "Descendente",
  "date_added": "Fecha añadida",
  "retry": "Reintentar",
  "with": "con",
  "or": "o",
  "format": "Formato",
  "username": "Nombre de usuario",
  "phone_number": "Número de teléfono",
  "email": "Correo electrónico",
  "change": "Cambiar",
  "save_changes": "Guardar cambios",
};
